import "./uploadImageArea.scss";
import { ReactComponent as ImageIcon } from "../../../assets/imageIcon.svg";
import { uniqueId } from "lodash";
import { useState } from "react";
import { FileApi } from "../../services/api/fileApi";
import { useLoadHandler } from "../../customHooks/useLoadHandler";
import { LoadingStatus } from "../../enums/loadingStatus";
import ReactLoading from "react-loading";
import { Color } from "../../style/colors";

export default function UploadImageArea(props: {
  image?: string;
  maxWidth?: string;
  height?: string;
  onChange?: (e: string) => void;
}) {
  const [id] = useState<string>(uniqueId());
  const [image, setImage] = useState<string | undefined>(props.image);

  const {
    loadingStatus: mobileLoadingStatus,
    callFetchAsync: mobileCallFetchAsync,
  } = useLoadHandler(async (file: File) => {
    let result = await FileApi.uploadFile(file);
    setImage(result);
    props.onChange?.(result);
  });

  return (
    <div
      className="upload-image-area"
      style={{
        height: props.height,
        maxWidth: props.maxWidth,
        backgroundImage: `url(${image})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
      onClick={() => {
        document.getElementById(id)?.click();
      }}
    >
      {mobileLoadingStatus == LoadingStatus.LOADING ? (
        <ReactLoading
          type={"spin"}
          color={Color().primaryColor}
          height={30}
          width={30}
        />
      ) : (
        <ImageIcon width={60} height={60} />
      )}
      <input
        type="file"
        accept="image/*"
        id={id}
        style={{ display: "none" }}
        onChange={(e) => mobileCallFetchAsync(e.target.files?.[0])}
      />
    </div>
  );
}
